const about = [
    {
        header: "Why Beds 4 Less Mattress Outlet?",
        body: [
            "We sell high quality, famous brand name mattresses at a fraction of retail cost.",
            "Our knowledgeable sales staff will answer all of your questions and help educate you about the benefits of each mattress, while assessing your personal sleep needs.",
            "Purchasing your new mattress at Beds 4 Less Mattress Outlet allows you to purchase the very best mattress your budget permits."
        ]
    },
    {
        header: "Mattresses and Foundations",   
        body: [`Beds 4 Less specializes in selling top quality bedding from major bedding manufacturers at a fraction of the retail cost. Our mattresses and foundations are overstocks, close-outs, freight returns, mismatched or products that do not meet the strict guidelines set by the manufacturer. They could include pieces that have minor blemishes or stitching flaws. Beds 4 Less strives to give customers the most information available regarding the nature of any cosmetic blemishes.
        
        We also carry Corsicana Bedding, a leader in low cost mattresses.  Corsicana Bedding items are all first-line products that carry a factory warranty.`]
    },
    {
        header: "Frames",
        body: ["Beds 4 Less offers high carbon steel frames from Mantua that are available to fit any size bed.  These frames will increase the life of your mattress set by giving it the necessary support it needs."]

    },
    {
        header: "Pillows",
        body: ["No good night of sleep is complete without a quality pillow.  At Beds 4 Less we offer a variety of pillows from Sleep Natural, including their patented SPA Memory Foam and Latex Foam."]
    },
    {
        header: "Mattress Protectors",
        body: ["Ensure the comfort, quality and longevity of your mattress with a Sleep Natural Mattress Protector.  This product is made of waterproof and breathable bamboo and cotton terry and will protect your mattress from stains and allergens."]
    }

];

export default about;